import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ColdexUserCompanyListModalState,
  Signal,
} from "../../../utils/interfaces/store/IStore";
import { IPayloadSetError } from "../../Interfaces";
import { CompanyXIndustryXColdex } from "../../../utils/types/CompanyXIndustryXColdex";
import { UserPartner } from "../../../utils/types/UserPartner";

const initialState: ColdexUserCompanyListModalState = {
  companiesByColdex: Signal.default(),
  companiesByColdexAndUser: Signal.default(),
  rows: [],
  search: "",
  page: 0,
  rowsPerPage: 10,
};

export const ColdexUserCompanyListModalSlice = createSlice({
  name: "ColdexUserCompanyListModal",
  initialState,
  reducers: {
    clean: (_, action: PayloadAction<undefined>) => {
      return {
        ...initialState,
        action: { ...action } as any,
      } as ColdexUserCompanyListModalState;
    },
    cleanNew: (state, action: PayloadAction<undefined>) => {
      return {
        ...state,
        companySaved: undefined,
      } as ColdexUserCompanyListModalState;
    },
    setSearch: (state, action: PayloadAction<string | undefined>) => {
      return {
        ...state,
        action: { ...action } as any,
        search: action.payload ?? "",
        rows: state.companiesByColdexAndUser?.value
          ?.map((userPartner: UserPartner) => {
            return state.companiesByColdex?.value?.find(
              (industry) =>
                industry?.code === userPartner?.category &&
                industry?.ndoc === userPartner?.partner
            );
          })
          .filter(
            (x) =>
              x?.description
                ?.toLowerCase()
                .includes(action.payload?.toLowerCase() ?? "") ||
              x?.companyName
                ?.toLowerCase()
                .includes(action.payload?.toLowerCase() ?? "")
          ),
      } as ColdexUserCompanyListModalState;
    },
    setPage: (state, action: PayloadAction<number>) => {
      return {
        ...state,
        action: { ...action } as any,
        page: action.payload,
      } as ColdexUserCompanyListModalState;
    },
    setRowPerPage: (state, action: PayloadAction<number>) => {
      return {
        ...state,
        action: { ...action } as any,
        rowsPerPage: action.payload,
      } as ColdexUserCompanyListModalState;
    },
    getCompaniesByColdex: (state, action: PayloadAction<undefined>) => {
      return {
        ...state,
        action: { ...action } as any,
        companiesByColdex: Signal.loading(),
      } as ColdexUserCompanyListModalState;
    },
    getCompaniesByColdexSuccess: (
      state,
      action: PayloadAction<CompanyXIndustryXColdex[]>
    ) => {
      return {
        ...state,
        action: { ...action } as any,
        companiesByColdex: Signal.success(
          action.payload.sort((a, b) =>
            `${a?.description} ${a?.companyName}`.localeCompare(
              `${b?.description} ${b?.companyName}`
            )
          )
        ) as any,
      } as ColdexUserCompanyListModalState;
    },
    getCompaniesByColdexError: (
      state,
      action: PayloadAction<IPayloadSetError>
    ) => {
      return {
        ...state,
        action: { ...action } as any,
        companiesByColdex: Signal.error(
          action.payload.error,
          action.payload.shorterror
        ),
      } as ColdexUserCompanyListModalState;
    },
    getCompaniesByColdexAndUser: (state, action: PayloadAction<undefined>) => {
      return {
        ...state,
        action: { ...action } as any,
        companiesByColdexAndUser: Signal.loading(),
      } as ColdexUserCompanyListModalState;
    },
    getCompaniesByColdexAndUserSuccess: (
      state,
      action: PayloadAction<UserPartner[]>
    ) => {
      return {
        ...state,
        action: { ...action } as any,
        companiesByColdexAndUser: Signal.success(action.payload) as any,
        rows: action.payload
          .map((userPartner: UserPartner) => {
            return state.companiesByColdex?.value?.find(
              (industry) =>
                industry?.code === userPartner?.category &&
                industry?.ndoc === userPartner?.partner
            );
          })
          .sort((a, b) =>
            `${a?.description} ${a?.companyName}`.localeCompare(
              `${b?.description} ${b?.companyName}`
            )
          ),
      } as ColdexUserCompanyListModalState;
    },
    getCompaniesByColdexAndUserError: (
      state,
      action: PayloadAction<IPayloadSetError>
    ) => {
      return {
        ...state,
        action: { ...action } as any,
        companiesByColdexAndUser: Signal.error(
          action.payload.error,
          action.payload.shorterror
        ),
      } as ColdexUserCompanyListModalState;
    },
    saveNewCompany: (state, action: PayloadAction<undefined>) => {
      return {
        ...state,
        action: { ...action } as any,
        companySaved: Signal.loading(),
      } as ColdexUserCompanyListModalState;
    },
    saveNewCompanySuccess: (state, action: PayloadAction<undefined>) => {
      return {
        ...state,
        action: { ...action } as any,
        companySaved: Signal.success(),
      } as ColdexUserCompanyListModalState;
    },
    saveNewCompanyError: (state, action: PayloadAction<IPayloadSetError>) => {
      return {
        ...state,
        action: { ...action } as any,
        companySaved: Signal.error(
          action.payload.error,
          action.payload.shorterror
        ),
      } as ColdexUserCompanyListModalState;
    },
  },
});
